const isSanityImage = (image) =>
  image._type === 'image' &&
  image.asset?._type === 'reference' &&
  typeof image.asset?._ref !== 'undefined';

export default isSanityImage;
